import React, {useEffect} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAppSelector} from "../../app/hooks";
import {setPasswordChangeIntent} from "../Passport/AccountInfo/ChangePassword/passwordChangeIntent";

export const PasswordChangeEntry = () => {

    const {token} = useAppSelector(state => state.auth)
    const {search} = useLocation()

    useEffect(() => {
        if (token) {
            setPasswordChangeIntent(true)
        }
    }, [])

    if (token) {
        return <Navigate to="/passport" replace/>
    }

    return <Navigate to={`/password/recovery${search}`} replace/>
}